module.exports = __webpack_public_path__ + "img/betguide-2.2f118f4e.svg";